/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Hero_TitleInputs */

const en_fw_hero_title = /** @type {(inputs: Fw_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding`)
};

const zh_fw_hero_title = /** @type {(inputs: Fw_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding" |
*
* @param {Fw_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_hero_title = /** @type {((inputs?: Fw_Hero_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Hero_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_hero_title(inputs)
	return zh_fw_hero_title(inputs)
});
export { fw_hero_title as "fw.hero.title" }